
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download-app",
      function () {
        return require("private-next-pages/download-app/index.js");
      }
    ]);
  